import { RouterProvider } from "react-router-dom";
import { router } from "@/app/router/routes";
import { QueryProvider } from "@/app/providers/QueryProvider";
import { SocketProvider } from "@/app/providers/SocketProvider";
import { Toaster } from "@/components/feedback/Toaster";

export function App() {
  return (
    <QueryProvider>
      <SocketProvider>
        <RouterProvider router={router} />
        <Toaster />
      </SocketProvider>
    </QueryProvider>
  );
}
